<template>
  <div
    v-if="
      !showFeatureAnalytic && !isAttachmentsFeatureFullscreen && !isProjectAnalysisFeatureFullscreen
    "
    class="view-buttons"
  >
    <div v-if="isDroneviewShowing" class="view-buttons-container">
      <MapViewButton @mapviewButtonClick="handleMapviewButtonClick" />
    </div>
    <div
      v-if="isMapviewShowing"
      :id="
        clickedItemType === 'realEstate' ||
        clickedItemType === 'poi' ||
        clickedItemType === 'line' ||
        clickedItemType === 'zone'
          ? 'buttons-on-mapview'
          : 'buttons-on-mapview-init'
      "
      class="view-buttons-container"
    >
      <SatelliteButton />
      <MapWmsButton
        v-if="wmsHoverButtons.length"
        :wmsHoverButtons="wmsHoverButtons"
        @MapWmsButtonHovered="hideButtonMenu"
      />
      <SelectRealEstateIvionButton
        v-if="
          isMapviewShowing &&
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone') &&
          hasIndoorviewAccess
        "
        @SelectRealEstateIvionButtonHovered="hideButtonMenu"
      />
      <MapOrthophotoButton
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone' ||
            isMapOrthophotoVisible) &&
          hasOrthophotoAccess
        "
        @MapOrthophotoButtonHovered="hideButtonMenu"
      >
      </MapOrthophotoButton>
      <MapDrawingButton
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone' ||
            isMapDrawingVisible) &&
          hasDrawingAccess
        "
        @MapDrawingButtonHovered="hideButtonMenu"
      />
      <DroneButton
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone') &&
          hasDroneviewAccess
        "
        @DroneButtonHovered="hideButtonMenu"
      />
      <MapFilterButton ref="MapFilterButtonRef" @MapFilterButtonHovered="hideButtonMenu" />
      <!-- MapVectorTileButton is a frontend demo for AH Umeå, currently real estate id 727903614376603648 on both dev and live -->
      <MapVectorTileButton
        v-if="realmId === 'akademiskahus' && selectedRealEstateId === '727903614376603648'"
        @MapVectorTileButtonHovered="hideButtonMenu"
      />
      <MapZonesButton
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone') &&
          hasZoneAccess
        "
        ref="MapZonesButtonRef"
        :categories="formattedMapLayers"
        :showZoneMenu="showZoneMenu"
        :showZoneMenuHover="showZoneMenuHover"
        :title="$t('general__data__area-zones')"
        @MapZoneButtonHovered="mapZoneButtonHovered"
        @closeHoverListMenu="closeZoneMenuHover"
        @onHoverListMenu="openZoneMenuHover"
        @mouseleave="closeZoneButtonHover"
        @onChecklistToggle="updateFilteredLayers"
      />
      <MapLineButton
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone') &&
          hasLineReaderAccess
        "
        ref="MapLineButtonRef"
        :categories="formattedLineLayers"
        :showLineMenu="showLineMenu"
        :showLineMenuHover="showLineMenuHover"
        :title="$t('general__view__lines')"
        @MapLineButtonHovered="mapLineButtonHovered"
        @closeHoverListMenu="closeLineMenuHover"
        @onHoverListMenu="openLineMenuHover"
        @mouseleave="closeLineButtonHover"
        @onChecklistToggle="updateFilteredLineLayers"
      />
      <MapPoiButton
        v-if="
          (clickedItemType === 'realEstate' ||
            clickedItemType === 'poi' ||
            clickedItemType === 'line' ||
            clickedItemType === 'zone') &&
          hasPoiReaderAccess
        "
        ref="MapPoiButtonRef"
        :categories="formattedPoiLayers"
        :showPoiMenu="showPoiMenu"
        :showPoiMenuHover="showPoiMenuHover"
        :title="$t('general__view__pois')"
        @MapPoiButtonHovered="mapPoiButtonHovered"
        @closeHoverListMenu="closePoiMenuHover"
        @onHoverListMenu="openPoiMenuHover"
        @mouseleave="closePoiButtonHover"
        @onChecklistToggle="updateFilterdPoiLayers"
      />
    </div>
    <div
      v-if="isPlanviewShowing || isModelviewShowing"
      id="buttons-on-planview"
      class="view-buttons-container"
    >
      <MapViewButton v-if="isPlanviewShowing" @mapviewButtonClick="handleMapviewButtonClick" />
      <ModelButton v-if="has3dModelAccess" @ModelButtonHovered="hideButtonMenu" />
      <SelectBuildingIvionButton
        v-if="isPlanviewShowing && hasIndoorviewAccess"
        @SelectBuildingIvionButtonHovered="hideButtonMenu"
      />
      <PanoramaViewButton v-if="hasPanoramaAccess" @PanoramaViewButtonHovered="hideButtonMenu" />
      <FloorOrthophotoButton
        v-if="hasOrthophotoAccess"
        @FloorOrthophotoButtonHovered="hideButtonMenu"
      />
      <FloorDrawingButton v-if="hasDrawingAccess" @FloorDrawingButtonHovered="hideButtonMenu" />
      <SensorDataButton v-if="hasSensorDataAccess" @SensorDataButtonHovered="hideButtonMenu" />
      <PlanViewFilterButton
        v-if="hasZoneAccess"
        ref="PlanViewFilterButtonRef"
        :showZoneMenu="showZoneMenu"
        :showZoneMenuHover="showZoneMenuHover"
        :categories="formattedPlanLayers"
        :title="$t('general__data__area-zones')"
        @closeHoverListMenu="closeZoneMenuHover"
        @onChecklistToggle="updateFilteredLayersPlanview"
        @PlanViewFilterButtonHovered="planviewFilterButtonHovered"
        @onHoverListMenu="openZoneMenuHover"
        @mouseleave="closeZoneButtonHover"
        @clicked="onPlanViewFilterButtonClicked"
      />
      <PlanviewPoiButton
        v-if="hasPoiReaderAccess"
        ref="PlanviewPoiButtonRef"
        :showPoiMenu="showPoiMenu"
        :showPoiMenuHover="showPoiMenuHover"
        :categories="formattedPlanPoiLayers"
        :title="$t('general__view__pois')"
        @PlanviewPoiButtonHovered="planViewPoiButtonHovered"
        @onChecklistToggle="updateFilteredPoiMapLayers"
        @mouseleave="closePoiButtonHover"
        @closeHoverListMenu="closePoiMenuHover"
        @onHoverListMenu="openPoiMenuHover"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useGeneralStore } from '@/pinia'
import { MAPVIEW_PREFIX, PLANVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_CLICKED_ITEM_TYPE, SET_POI_MENU, SET_SHOW_ZONE_MENU } from '@/store/mutation-types'
import {
  GET_INDOOR_ZONE_DATA_FOR_LEVEL,
  GET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE,
  GET_OUTDOOR_POI_DATA_FOR_REAL_ESTATE
} from '@/store/action-types'
import { orderAlphabetical } from '@/utils/sort'
import { getRealmId } from '@/utils/realmId'
import { setViewToMapview } from '@/utils/views'
import { zoomToEntities } from '@/composables/useMapbox'
import * as turf from '@turf/turf'
import booleanIntersects from '@turf/boolean-intersects'
import { Line } from '@/services/lines.service'
import { ZoneLayer } from '@/services/zones.service'
// Import all button components
import SelectBuildingIvionButton from '@/components/general/ViewButtons/indoorview-buttons/SelectBuildingIvionButton.vue'
import SelectRealEstateIvionButton from '@/components/general/ViewButtons/indoorview-buttons/SelectRealEstateIvionButton.vue'
import {
  DroneButton,
  MapDrawingButton,
  MapFilterButton,
  MapLineButton,
  MapPoiButton,
  MapVectorTileButton,
  MapWmsButton,
  SatelliteButton,
  MapZonesButton,
  MapOrthophotoButton
} from './mapview-buttons'
import {
  FloorDrawingButton,
  FloorOrthophotoButton,
  MapViewButton,
  ModelButton,
  PlanViewFilterButton,
  SensorDataButton,
  PanoramaViewButton,
  PlanviewPoiButton
} from './planview-buttons'

// Pinia store
const piniaStore = useGeneralStore()
const store = useStore()

// Data (reactive state)
const lineMenuHovered = ref(false)
const poiMenuHovered = ref(false)
const zoneMenuHovered = ref(false)
const showLineMenuHover = ref(false)
const showPoiMenuHover = ref(false)
const showZoneMenuHover = ref(false)
const wmsHoverButtons = ref<any[]>([])
const zoneMenuOpenedByClick = ref(false)

// Computed properties (from Vuex and Pinia)
const has3dModelAccess = computed(() => store.getters.has3dModelAccess)
const hasDrawingAccess = computed(() => store.getters.hasDrawingAccess)
const hasDroneviewAccess = computed(() => store.getters.hasDroneviewAccess)
const hasIndoorviewAccess = computed(() => store.getters.hasIndoorviewAccess)
const hasLineReaderAccess = computed(() => store.getters.hasLineReaderAccess)
const hasOrthophotoAccess = computed(() => store.getters.hasOrthophotoAccess)
const hasPoiReaderAccess = computed(() => store.getters.hasPoiReaderAccess)
const hasSensorDataAccess = computed(() => store.getters.hasSensorDataAccess)
const hasPanoramaAccess = computed(() => store.getters.hasPanoramaAccess)
const hasZoneAccess = computed(() => store.getters.hasZoneAccess)
const isDroneviewShowing = computed(() => store.getters.isDroneviewShowing)
// const isIndoorviewShowing = computed(() => store.getters.isIndoorviewShowing)
const isMapviewShowing = computed(() => store.getters.isMapviewShowing)
const isModelviewShowing = computed(() => store.getters.isModelviewShowing)
const isPlanviewShowing = computed(() => store.getters.isPlanviewShowing)
const selectedRealEstateId = computed(() => store.getters[`${MAPVIEW_PREFIX}/selectedRealEstateId`])
const selectedLevelId = computed(() => store.getters.selectedLevelId)
const selectedBuilding = computed(() => store.state[MAPVIEW_PREFIX].selectedBuilding)
// const selectedRealEstate = computed(() => store.state[MAPVIEW_PREFIX].selectedRealEstate)
const filteredMapLayers = computed(() => store.state[MAPVIEW_PREFIX].filteredLayers)
const filteredMapPoiLayers = computed(() => store.state[MAPVIEW_PREFIX].filteredPoiLayers)
const filteredPlanviewLayers = computed(() => store.state[PLANVIEW_PREFIX].filteredLayers)
const filteredPlanViewPoisLayers = computed(
  () => store.state[PLANVIEW_PREFIX].poiCategoriesForSelectedLevel
)
const filteredDrawings = computed(() => piniaStore.filteredDrawings)
const filteredLineLayers = computed(() => piniaStore.filteredLineLayers)
const filteredOrthophotos = computed(() => piniaStore.filteredOrthophotos)
const filteredWmsLayers = computed(() => piniaStore.filteredWmsLayers)
const isFeatureFullscreen = computed(() => piniaStore.isFeatureFullscreen)
const showFeatureAnalytic = computed(() => piniaStore.showFeatureAnalytic)
const showFeatureAttachments = computed(() => piniaStore.showFeatureAttachments)
const showFeatureProjectAnalysis = computed(() => piniaStore.showFeatureProjectAnalysis)
const showLineMenu = computed(() => piniaStore.showLineMenu)
const clickedItemType = computed(() => store.state.clickedItemType)
const previousView = computed(() => store.state.previousView)
const showZoneMenu = computed(() => store.state.showZoneMenu)
const showPoiMenu = computed(() => store.state.showPoiMenu)
const mobileScreen = computed(() => store.state.mobileScreen)
const routeUrl = computed(() => store.state.route?.fullPath ?? '')
const realmId = computed(() => getRealmId())

// Formatting computed
const formattedLineLayers = computed(() => {
  const lineLayers: Line[] = []
  filteredLineLayers.value.forEach((layer) => {
    if (layer.types?.length) {
      lineLayers.push(layer)
    }
  })
  return lineLayers.length ? lineLayers.sort(orderAlphabetical) : []
})
const formattedMapLayers = computed(() => {
  const zoneLayers: ZoneLayer[] = []
  filteredMapLayers.value.forEach((layer) => {
    if (layer.id !== 'building' && layer.id !== 'realestates' && layer.types?.length) {
      zoneLayers.push(layer)
    }
  })
  return zoneLayers.length ? zoneLayers.sort(orderAlphabetical) : []
})
const formattedPlanLayers = computed(() => {
  const zoneLayers: any[] = []
  filteredPlanviewLayers.value.forEach((layer) => {
    if (layer.id !== 'building' && layer.id !== 'realestates' && layer.types?.length) {
      zoneLayers.push(layer)
    }
  })
  return zoneLayers.length ? zoneLayers.sort(orderAlphabetical) : []
})
const formattedPoiLayers = computed(() => {
  const poiLayers: any[] = []
  filteredMapPoiLayers.value.forEach((layer) => {
    if (layer.types?.length) poiLayers.push(layer)
  })
  return poiLayers.length ? poiLayers.sort(orderAlphabetical) : []
})
const formattedPlanPoiLayers = computed(() => {
  const poiLayers: any[] = []
  filteredPlanViewPoisLayers.value.forEach((layer) => {
    if (layer.types?.length) poiLayers.push(layer)
  })
  return poiLayers.length ? poiLayers.sort(orderAlphabetical) : []
})
const isAttachmentsFeatureFullscreen = computed(
  () => showFeatureAttachments.value && isFeatureFullscreen.value
)
const isMapDrawingVisible = computed(
  () =>
    filteredDrawings.value.length &&
    filteredDrawings.value.filter((drawing) => drawing.visible).length
)
const isMapOrthophotoVisible = computed(
  () =>
    filteredOrthophotos.value.length &&
    filteredOrthophotos.value.filter((orthophoto) => orthophoto.visible).length
)
const isProjectAnalysisFeatureFullscreen = computed(
  () => showFeatureProjectAnalysis.value && isFeatureFullscreen.value
)

const MapLineButtonRef = ref()
const MapPoiButtonRef = ref()
const MapZonesButtonRef = ref()
const MapFilterButtonRef = ref()
const PlanViewFilterButtonRef = ref()
const PlanviewPoiButtonRef = ref()

const refs = {
  MapLineButton: MapLineButtonRef,
  MapPoiButton: MapPoiButtonRef,
  MapZonesButton: MapZonesButtonRef,
  MapFilterButton: MapFilterButtonRef,
  PlanViewFilterButton: PlanViewFilterButtonRef,
  PlanviewPoiButton: PlanviewPoiButtonRef
}
// Watchers for WMS hover buttons
watch(
  () => routeUrl.value,
  () => {
    if (!filteredWmsLayers.value.length) {
      wmsHoverButtons.value = []
      return
    }
    setWmsHoverButtons(filteredWmsLayers.value)
  },
  { immediate: true }
)
watch(
  filteredWmsLayers,
  (newList) => {
    if (!newList.length) {
      wmsHoverButtons.value = []
      return
    }
    setWmsHoverButtons(newList)
  },
  { deep: true, immediate: true }
)

// Methods
function setWmsHoverButtons(newList: any[]) {
  const hoverButtons: any[] = []
  // @ts-expect-error - map not typed
  if (!store.map) {
    wmsHoverButtons.value = hoverButtons
    return
  }
  // @ts-expect-error - map not typed
  const bounds = store.map.getBounds()
  const bbox: [number, number, number, number] = [
    bounds.getWest(),
    bounds.getSouth(),
    bounds.getEast(),
    bounds.getNorth()
  ]
  const mapPolygon = turf.bboxPolygon(bbox)
  newList.forEach((wmsSource) => {
    const boundingBoxPolygon = turf.bboxPolygon([
      +wmsSource.boundingBox[0],
      +wmsSource.boundingBox[1],
      +wmsSource.boundingBox[2],
      +wmsSource.boundingBox[3]
    ])
    if (
      turf.booleanWithin(boundingBoxPolygon, mapPolygon) ||
      booleanIntersects(boundingBoxPolygon, mapPolygon)
    ) {
      hoverButtons.push(wmsSource)
    }
  })
  wmsHoverButtons.value = hoverButtons
}

function mapLineButtonHovered() {
  if (!mobileScreen.value) showLineMenuHover.value = true
  if (refs.MapFilterButton) refs.MapFilterButton.value?.hideHoverButtons()
  if (refs.MapPoiButton) refs.MapPoiButton.value?.hideHoverButtons()
  if (refs.MapZonesButton) refs.MapZonesButton.value?.hideHoverButtons()
}

function mapPoiButtonHovered() {
  if (!mobileScreen.value) showPoiMenuHover.value = true
  if (refs.MapFilterButton) refs.MapFilterButton.value?.hideHoverButtons()
  if (refs.MapLineButton) refs.MapLineButton.value?.hideHoverButtons()
  if (refs.MapZonesButton) refs.MapZonesButton.value?.hideHoverButtons()
}

function planViewPoiButtonHovered() {
  if (!mobileScreen.value) showPoiMenuHover.value = true
  if (refs.PlanViewFilterButton) refs.PlanViewFilterButton.value?.hideHoverButtons()
  zoneMenuHovered.value = false
  showZoneMenuHover.value = false
}

function mapZoneButtonHovered() {
  if (!mobileScreen.value) showZoneMenuHover.value = true
  if (refs.MapFilterButton) refs.MapFilterButton.value?.hideHoverButtons()
  if (refs.MapLineButton) refs.MapLineButton.value?.hideHoverButtons()
  if (refs.MapPoiButton) refs.MapPoiButton.value?.hideHoverButtons()
}

function planviewFilterButtonHovered() {
  if (!mobileScreen.value) showZoneMenuHover.value = true
  if (showPoiMenu.value) setPoiMenu(false)
}

async function handleMapviewButtonClick() {
  // await new Promise((resolve) => setTimeout(resolve, 200)) // Wait for the map to be ready
  if (previousView.value !== 'droneview') {
    setClickedItemType({ type: 'level' })
  }
  await setViewToMapview()
  zoomToEntities([selectedBuilding.value.id])
}

function hideButtonMenu() {
  setShowLineMenu(false)
  setPoiMenu(false)
  setShowZoneMenu(false)
}

function closeLineButtonHover() {
  if (!lineMenuHovered.value) {
    showLineMenuHover.value = false
  }
}
function closeLineMenuHover() {
  lineMenuHovered.value = false
  showLineMenuHover.value = false
}
function openLineMenuHover() {
  showLineMenuHover.value = true
  lineMenuHovered.value = true
  showZoneMenuHover.value = false
  zoneMenuOpenedByClick.value = false
}
function closeZoneButtonHover() {
  if (!zoneMenuHovered.value) {
    showZoneMenuHover.value = false
  }
}
function openZoneMenuHover() {
  showZoneMenuHover.value = true
  zoneMenuHovered.value = true
}
function closeZoneMenuHover() {
  if (!zoneMenuOpenedByClick.value) {
    zoneMenuHovered.value = false
    showZoneMenuHover.value = false
  }
}
function closePoiButtonHover() {
  if (!poiMenuHovered.value) {
    showPoiMenuHover.value = false
  }
}
function openPoiMenuHover() {
  showPoiMenuHover.value = true
  poiMenuHovered.value = true
  zoneMenuHovered.value = false
  showZoneMenuHover.value = false
  zoneMenuOpenedByClick.value = false
}
function closePoiMenuHover() {
  showPoiMenuHover.value = false
  poiMenuHovered.value = false
}
function updateFilteredLayers(typeId: string, categoryId: string, checked: boolean) {
  const isOutdoorZoneLayer = categoryId !== 'building' && categoryId !== 'realestates'
  if (isOutdoorZoneLayer) {
    getOutdoorZoneDataForRealEstate({
      categoryId: categoryId,
      realEstateId: selectedRealEstateId.value,
      typeId: typeId,
      checked: checked
    })
  }
}
function updateFilteredLayersPlanview(typeId: string, categoryId: string, checked: boolean) {
  getIndoorZoneDataForLevel({
    categoryId: categoryId,
    levelId: selectedLevelId.value,
    typeId: typeId,
    checked: checked
  })
}
function updateFilteredLineLayers(typeId: string, categoryId: string, checked: boolean) {
  const coreId = selectedRealEstateId.value // When adding lines to planview, this function should be possible to reuse
  piniaStore.updateLineDataForCoreEntity(categoryId, typeId, coreId, checked)
}
async function updateFilterdPoiLayers(typeId: string, categoryId: string, checked: boolean) {
  getOutdoorPoiDataForRealEstate({
    categoryId: categoryId,
    typeId: typeId,
    realEstateId: selectedRealEstateId.value,
    checked: checked
  })
}
async function updateFilteredPoiMapLayers(typeId: string, categoryId: string, checked: boolean) {
  await store.dispatch('planview/getPoisForLevelPerCategory', {
    categoryId: categoryId,
    typeId: typeId,
    checked: checked,
    levelId: selectedLevelId.value
  })
}

// Vuex/Pinia actions and mutations
function setClickedItemType(payload: any) {
  store.commit(SET_CLICKED_ITEM_TYPE, payload)
}
function setShowZoneMenu(value: boolean) {
  store.commit(SET_SHOW_ZONE_MENU, value)
}
function setPoiMenu(value: boolean) {
  store.commit(SET_POI_MENU, value)
}
function getOutdoorZoneDataForRealEstate(payload: any) {
  store.dispatch(`${MAPVIEW_PREFIX}/${GET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE}`, payload)
}
function getOutdoorPoiDataForRealEstate(payload: any) {
  store.dispatch(`${MAPVIEW_PREFIX}/${GET_OUTDOOR_POI_DATA_FOR_REAL_ESTATE}`, payload)
}
function getIndoorZoneDataForLevel(payload: any) {
  store.dispatch(`${PLANVIEW_PREFIX}/${GET_INDOOR_ZONE_DATA_FOR_LEVEL}`, payload)
}
function setShowLineMenu(value: boolean) {
  piniaStore.setShowLineMenu(value)
}
function onPlanViewFilterButtonClicked(value: boolean) {
  zoneMenuOpenedByClick.value = value
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables' as old-variables;
@use '@/styles/mixins';
.view-buttons-container {
  display: flex;
  align-items: flex-end;
}
.view-buttons {
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: absolute;
  left: calc(#{old-variables.$margin-small + old-variables.$margin-small});
  bottom: calc(#{old-variables.$margin-small + old-variables.$margin-small});
  z-index: variables.$z-index-view-buttons-mobile;
  &--centered {
    left: calc(50% - 61px);
  }
}
@media screen and (max-width: 1024px) {
  .view-buttons {
    background: transparent;
    bottom: 0;
    height: variables.$view-buttons-height;
    justify-content: center;
    left: 0;
    position: absolute;
    overflow-y: visible;
    width: 100vw;
    z-index: variables.$z-index-view-buttons-mobile;

    > div {
      column-gap: variables.$gap-medium;
      height: fit-content;
      justify-content: center;
      padding-bottom: variables.$padding-large;
      z-index: 30;
      @include mixins.scrollbar-thin;

      &#buttons-on-planview,
      &#buttons-on-mapview:not(.buttons-on-mapview-init) {
        justify-content: center;
        overflow-x: scroll;
        padding: 0 20px 10px;
        @media screen and (max-width: 658px) {
          justify-content: flex-start;
        }
      }
    }
  }
}
</style>
